import React from 'react';
import moment from 'moment-timezone';

import { fixDecimals } from '../../../helpers';
import { PlayerBallFlightListPropsType } from './types';
import { useRouter } from '../../../helpers/customHooks';
import { useTablePropertiesState, useDataEventsState } from '../../../store/hooks';
import { PAST_GAME } from 'config/constants';

const PlayerBallFlightList = ({ sessionName, playerBallFlightList }: PlayerBallFlightListPropsType) => {
  
  const { specificScope } = useRouter();
  const { orderColumn: orderingBy = 0 } = useTablePropertiesState(specificScope);
  const { dataEvent: data } = useDataEventsState();
  
  const flights: JSX.Element[] = [];
  let index = 0;
  playerBallFlightList.sort((first, second) => {
    switch (Math.abs(orderingBy)) {
      case 2:
        return orderingBy === 2 ? first.flightType.localeCompare(second.flightType) :
          first.flightType.localeCompare(second.flightType) * -1;
      case 3:
        return orderingBy === 3 ? first.initialAirSpeedMPH - second.initialAirSpeedMPH :
          second.initialAirSpeedMPH - first.initialAirSpeedMPH;
      case 4:
        return orderingBy === 4 ? first.initialRotationRPM - second.initialRotationRPM :
          second.initialRotationRPM - first.initialRotationRPM;
      case 5:
        return orderingBy === 5 ? first.flightDurationSec - second.flightDurationSec :
          second.flightDurationSec - first.flightDurationSec;
      case 6:
        return orderingBy === 6 ? first.peakHeightFt - second.peakHeightFt :
          second.peakHeightFt - first.peakHeightFt;
      case 7:
        return orderingBy === 7 ? first.groundDistanceYds - second.groundDistanceYds :
          second.groundDistanceYds - first.groundDistanceYds;
      case 8:
        return orderingBy === 8 ? first.startTimeMS - second.startTimeMS :
          second.startTimeMS - first.startTimeMS;
      default:
        return 0;
    }
  });
  playerBallFlightList.forEach(flight => {
    index++;
    if (index === 1) {
      flights.push(
        <div key={index} className="a-body-00">
          <div
            style={{
              width: '100px',
              padding: '17px 15px',
              background: '#E0E9EF',
              borderLeft: '1px solid #cecece',
              borderRight: '1px solid #cecece',
              overflow: 'hidden'
            }}
          >
            <h6>{sessionName}</h6>
          </div>
          <div className="a-tbody-00">
            <div style={{ width: '90px', padding: '0px 15px' }}>
              <p>{flight.flightType}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.initialAirSpeedMPH, 1)}</p>
            </div>
            <div style={{ width: '80px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.initialRotationRPM, 0)}</p>
            </div>
            <div style={{ width: '95px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.flightDurationSec, 2)}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.peakHeightFt, 1)}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{flight.groundDistanceYds>=0?fixDecimals(flight.groundDistanceYds, 1):'-'}</p>
            </div>
            <div style={{ width: '80px', padding: '0px 15px' }}>
              {data.meta.type !== PAST_GAME || sessionName === 'Pre-Game'?
              <p>{moment(flight.startTimeMS).format('hh:mm:ss')}</p>
              :
              <p>{flight.playId}</p>
              }
              
            </div>
          </div>
        </div>
      );
    } else {
      flights.push(
        <div key={index} className="a-body-00">
          <div
            style={{
              width: '100px',
              padding: '17px 15px',
              background: '#E0E9EF',
              borderLeft: '1px solid #cecece',
              borderRight: '1px solid #cecece'
            }}
          >
          </div>
          <div className="a-tbody-00">
            <div style={{ width: '90px', padding: '0px 15px' }}>
              <p>{flight.flightType}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.initialAirSpeedMPH, 1)}</p>
            </div>
            <div style={{ width: '80px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.initialRotationRPM, 0)}</p>
            </div>
            <div style={{ width: '95px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.flightDurationSec, 2)}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{fixDecimals(flight.peakHeightFt, 1)}</p>
            </div>
            <div style={{ width: '75px', padding: '0px 15px' }}>
              <p>{flight.groundDistanceYds >=0 ? fixDecimals(flight.groundDistanceYds, 1): '-'}</p>
            </div>
            <div style={{ width: '80px', padding: '0px 15px' }}>
            {data.meta.type !== PAST_GAME?
              <p>{moment.tz(flight.startTimeMS, moment.tz.guess()).format('hh:mm:ss')}</p>
              :
              <p>{flight.playId}</p>
            }
            </div>
          </div>
        </div>
      );
    }
  });
  
  return <div>{flights}</div>;
};

export default PlayerBallFlightList;
